export const AUTHORIZATION_TYPE_ALL = 'All';
export const AUTHORIZATION_TYPE_AUTHORISED = 'Authorised';
export const AUTHORIZATION_TYPE_TOBE = 'ToBeAuthorise';